/**
 * Calendar API Client
 *
 * iCal calendar feed generation and subscription management.
 */

import apiClient from './client';

// Response types
export interface CalendarToken {
  token: string;
  feedUrl: string;
  webcalUrl: string;
}

export interface ExportOptions {
  start?: string;
  end?: string;
  completed?: boolean;
}

/**
 * Calendar API methods
 */
export const calendarApi = {
  /**
   * Generate calendar subscription token
   */
  async getToken(): Promise<CalendarToken> {
    const response = await apiClient.get('/calendar/token');
    return response.data;
  },

  /**
   * Get calendar export URL with options
   */
  getExportUrl(options: ExportOptions = {}): string {
    const baseUrl = apiClient.defaults.baseURL || '';
    const params = new URLSearchParams();

    if (options.start) params.append('start', options.start);
    if (options.end) params.append('end', options.end);
    if (options.completed) params.append('completed', 'true');

    const queryString = params.toString();
    return `${baseUrl}/calendar/export${queryString ? `?${queryString}` : ''}`;
  },

  /**
   * Download calendar export file
   */
  async downloadExport(options: ExportOptions = {}): Promise<Blob> {
    const params = new URLSearchParams();

    if (options.start) params.append('start', options.start);
    if (options.end) params.append('end', options.end);
    if (options.completed) params.append('completed', 'true');

    const response = await apiClient.get('/calendar/export', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },
};
